<div class="auth-page-wrapper auth-bg-cover py-5 d-flex justify-content-center align-items-center min-vh-100">
  <div class="bg-overlay"></div>
  <div class="auth-page-content overflow-hidden pt-lg-5">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="card overflow-hidden">
            <div class="row g-0">
              <div class="col-lg-6">
                <div class="p-lg-5 p-4 auth-one-bg h-100">
                  <div class="bg-overlay"></div>
                  <div class="position-relative h-100 d-flex flex-column">
                    <div class="mb-4">
                      <a routerLink="/" class="d-block">
                        <img src="assets/images/logo-light.png" alt="" height="50">
                      </a>
                    </div>
                    <div class="mt-auto">
                      <div class="mb-3">
                        <i class="ri-double-quotes-l display-4 text-light"></i>
                      </div>

                      <div id="quotescarouselIndicators" class="carousel slide" data-bs-ride="carousel">
                        <div class="carousel-indicators">
                          <button type="button" data-bs-target="#quotescarouselIndicators" data-bs-slide-to="0"
                            class="active" aria-current="true" aria-label="Slide 1"></button>
                          <button type="button" data-bs-target="#quotescarouselIndicators" data-bs-slide-to="1"
                            aria-label="Slide 2"></button>
                          <button type="button" data-bs-target="#quotescarouselIndicators" data-bs-slide-to="2"
                            aria-label="Slide 3"></button>
                        </div>

                        <div class="carousel-inner text-center text-white pb-5">
                          <div class="carousel-item active">
                            <p class="fs-15 fst-italic">
                              " Gérez vos apprenants, leurs accès aux formations et leurs progrès en toute simplicité. "
                            </p>
                          </div>

                          <div class="carousel-item">
                            <p class="fs-15 fst-italic">
                              " Suivez en temps réel les achats de formations crypto et options binaires depuis votre
                              tableau de bord. "
                            </p>
                          </div>

                          <div class="carousel-item">
                            <p class="fs-15 fst-italic">
                              " Une plateforme d’administration qui vous permet d’optimiser la gestion de vos contenus,
                              ventes et utilisateurs. "
                            </p>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-6">
                <div class="p-lg-5 p-4">
                  <div>
                    <h5 class="text-primary">Connexion</h5>
                    <p class="text-muted">Panel d'administration de Sapptrading Pro.</p>
                  </div>

                  <div class="mt-4">
                    <form novalidate [formGroup]="loginForm" (ngSubmit)="signIn()">

                      <div class="mb-3">
                        <label class="form-label" for="username">Nom d'utilisateur</label>
                        <input type="text" class="form-control" placeholder="email ou numéro de telephone" id="username"
                          formControlName="username" [ngClass]="{ 'is-invalid': submitted && form['username'].errors }">
                        <div *ngIf="submitted && form['username'].errors" class="invalid-feedback">
                          <div *ngIf="form['username'].errors['required']"> Le nom d'utilisateur est obligatoire </div>
                        </div>
                      </div>

                      <div class="mb-3">
                        <div class="float-end">
                          <a href="javascript:;" (click)="forgotPassword()" class="text-muted">Mot de passe oublié ?</a>
                        </div>
                        <label class="form-label" for="password">Mot de passe</label>
                        <div class="position-relative auth-pass-inputgroup mb-3">
                          <input #password id="password" class="form-control pe-5 password-input"
                            placeholder="Entrez votre mot de passe" formControlName="password" type="password"
                            [ngClass]="{ 'is-invalid': submitted && form['password'].errors }">
                          <button (click)="togglePassword(password)"
                            class="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted password-addon"
                            type="button" id="password-addon"><i
                              [ngClass]="{ 'ri-eye-off-fill': showPassword, 'ri-eye-fill ': !showPassword }"
                              class="align-middle"></i></button>
                          <div *ngIf="submitted && form['password'].errors" class="invalid-feedback">
                            <div *ngIf="form['password'].errors['required']"> Le mot de passe est obligatoire </div>
                          </div>
                        </div>
                      </div>

                      <div class="mt-4">
                        <button class="btn btn-primary w-100 " type="submit">
                          {{loading? 'Veuillez patienter ' : 'Se connecter' }}
                          <span class="{{ loading? 'spinner-border spinner-border-sm ms-2' : '' }}" role="status">
                          </span>
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

  <footer class="footer">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="text-center text-white">
            <p class="mb-0">&copy;
              <script>document.write(new Date().getFullYear())</script> SappTradingPro. Crafted with <i
                class="mdi mdi-heart text-danger"></i> by <a href="#" target="_blank" class="text-reset">SA</a>.
            </p>
          </div>
        </div>
      </div>
    </div>
  </footer>
</div>
